import { Injectable, Type } from "@angular/core";
import { NatCatalogRepository } from "@natiwi/core/network/repositories/catalog.repository";
import { NatRestAdapter } from "@natiwi/core/network/adapters/rest.adapter";
import { OrmContactKind } from "@natiwi/shared/models/contact-kind.model";

export class NatContactKindRepository extends NatCatalogRepository<OrmContactKind> {

    constructor(adapter?: NatRestAdapter) {
        super(adapter);
        let repoUrl: string = '/contactKinds';
        let repoModel: Type<OrmContactKind> = OrmContactKind;
        this.init(repoUrl, repoModel);
    }
}